// ABOUTME: Guards legacy Settings routes using completed local feature rollouts.
// ABOUTME: Redirects routes whose inverted feature condition is active.
import {Feature} from '@hconnect/common/enums'
import React from 'react'
import {Outlet, Navigate} from 'react-router'

import {useSettingsFeature} from '../../common/hooks'
import {getUrl} from '../helpers'
import {ROUTES} from '../routes'

interface FeatureGuardedRouteProps {
  feature: Feature
  shouldBypassFeature?: boolean
  shouldInvert?: boolean
}

export const FeatureGuardedRoute: React.FC<FeatureGuardedRouteProps> = ({
  feature,
  shouldBypassFeature = false,
  shouldInvert = false
}) => {
  const isFeatureAvailable = useSettingsFeature(feature)

  const shouldNavigate = isFeatureAvailable !== shouldInvert || shouldBypassFeature

  if (shouldNavigate) {
    return <Outlet />
  }

  return <Navigate to={getUrl(ROUTES.BASE.NOT_FOUND.path, {})} replace />
}
